import { memo } from 'react';
import { ComponentMemo } from '@headless-workspace/typings';
import { GlowTypography } from './GlowTypography';
import { GlowTypographyProps } from './GlowTypographyProps';

export const GlowTextBodySmall: ComponentMemo<GlowTypographyProps> = memo(({ fontSize = 'bodySmall', ...props }) => {
    return <GlowTypography fontSize={'bodySmall'} {...props} />;
});

GlowTextBodySmall.displayName = 'GlowTextBodySmall';
